import React from 'react';
import {View} from 'react-native';
import {NewsCard} from '../../../../shared/components/newsCard';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {ViewProps} from './model';

export default ({prevNews, nextNews}: ViewProps) => {
  const styles = useStyles(() => ({
    container: {
      flexWrap: 'wrap',
      paddingBottom: 100,
      flexDirection: 'row',
      justifyContent: 'center',
    },
    cardContainer: {
      paddingTop: 40,
      width: 645,
      marginHorizontal: 15,
    },
    label: {
      marginBottom: 30,
    },
    newsCard: {
      flexGrow: 1,
    },
  }));

  return (
    <View style={styles.container}>
      <View style={styles.cardContainer}>
        <Text type='h2' style={styles.label}>
          Предыдущая
        </Text>
        <NewsCard news={prevNews} style={styles.newsCard} />
      </View>
      <View style={styles.cardContainer}>
        <Text type='h2' style={styles.label}>
          Следующая
        </Text>
        <NewsCard news={nextNews} style={styles.newsCard} />
      </View>
    </View>
  );
};
